import { useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = 'gm_session_id';

function getOrCreateSessionId() {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) ||
      `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

/**
 * Lightweight first-party page view tracker.
 * Skips admin/login pages and respects Do Not Track.
 */
export function usePageTracking(page) {
  useEffect(() => {
    // Honor Do Not Track
    if (navigator.doNotTrack === '1' || window.doNotTrack === '1') return;

    // Skip internal admin/login pages
    const path = (page || window.location.pathname || '/').toLowerCase();
    if (path.startsWith('/admin') || path.startsWith('/login')) return;

    const sessionId = getOrCreateSessionId();
    const referrer = document.referrer || '';

    // Avoid awaiting; fire-and-forget. Use a bare axios call (no auth interceptor needs).
    axios.post(`${BACKEND_URL}/api/analytics/track`, {
      page: path,
      referrer,
      session_id: sessionId,
    }).catch(() => {
      // Silently ignore tracking failures
    });
  }, [page]);
}
